import React, { ReactNode } from 'react';
import { Button } from '@/components/ui/button';
import { Crown } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface PremiumContentWrapperProps {
  /** Content to render (will be shown but disabled) */
  children: ReactNode;
  /** Whether user has access to this feature */
  hasAccess: boolean;
  /** Feature name for messaging */
  featureName?: string;
}

export const PremiumContentWrapper: React.FC<PremiumContentWrapperProps> = ({
  children,
  hasAccess,
  featureName = 'feature'
}) => {
  const navigate = useNavigate();

  if (hasAccess) {
    return <>{children}</>;
  }

  return (
    <div className="space-y-6">
      {/* Upgrade Banner */}
      <div className="bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-200 rounded-lg p-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="rounded-full bg-blue-100 p-2">
              <Crown className="h-5 w-5 text-blue-600" />
            </div>
            <div>
              <h4 className="font-medium text-gray-900">
                Upgrade to Advanced to enable {featureName}
              </h4>
              <p className="text-sm text-gray-600">
                Unlock advanced features and take your hive to the next level
              </p>
            </div>
          </div>
          <Button
            onClick={() => navigate('/admin/settings/subscription-center')}
            size="sm"
            className="bg-blue-600 hover:bg-blue-700"
          >
            Upgrade to Advanced
          </Button>
        </div>
      </div>

      {/* Preview Content - Disabled */}
      <div className="opacity-60 pointer-events-none select-none">
        {children}
      </div>
    </div>
  );
};